import { useEffect, useContext, useMemo } from "react"
import { Box } from "@mui/material"
import { api } from "../../../services/api"
import { externalComponent } from "../../AppRoutes"
import Table from "../../Table"
import { formatCurrency } from "../../Utils/functions"
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const url = '/novopedido/ficha/'

const initialize = async (id, setData, setLoader) => {
    setLoader(true)
    const res = await api.get(url + id + '/')
    if (res.status === 200) {
        setData({ rows: res.data, loaded: true })
    }
    setLoader(false)
}

const generateColumns = () => {
    const documentos_em_aberto = []
    const documentos_quitados = []
    const empresas_do_grupo = []

    documentos_em_aberto.push({ field: 'numero', headerName: 'Número', flex: 1 })
    documentos_em_aberto.push({ field: 'emissao', headerName: 'Emissão', flex: 1, renderCell: ({ value }) => value ? dayjs.utc(value).format('DD/MM/YYYY') : '' })
    documentos_em_aberto.push({ field: 'vencimento', headerName: 'Vencimento', flex: 1, renderCell: ({ value }) => value ? dayjs.utc(value).format('DD/MM/YYYY') : '' })
    documentos_em_aberto.push({ field: 'valornamoeda1', headerName: 'Valor', flex: 1, valueGetter:({value}) => Number(value || 0), renderCell: ({ value }) => formatCurrency(value || 0) })
    documentos_em_aberto.push({ field: 'saldoemaberto', headerName: 'Saldo', flex: 1, valueGetter:({value}) => Number(value || 0), renderCell: ({ value }) => formatCurrency(value || 0) })
    documentos_em_aberto.push({ field: 'atraso', headerName: 'Atraso', flex: 1 })
    documentos_em_aberto.push({ field: 'tipo_doc', headerName: 'Tipo Doc', flex: 1 })
    documentos_em_aberto.push({ field: 'cliente', headerName: 'Cliente', flex: 1 })


    documentos_quitados.push({ field: 'numero', headerName: 'Número', flex: 1 })
    documentos_quitados.push({ field: 'emissao', headerName: 'Emissão', flex: 1, renderCell: ({ value }) => value ? dayjs.utc(value).format('DD/MM/YYYY') : '' })
    documentos_quitados.push({ field: 'pgto', headerName: 'Pagamento', flex: 1, renderCell: ({ value }) => value ? dayjs.utc(value).format('DD/MM/YYYY') : '' })
    documentos_quitados.push({ field: 'vencimento', headerName: 'Vencimento', flex: 1, renderCell: ({ value }) => value ? dayjs.utc(value).format('DD/MM/YYYY') : '' })
    documentos_quitados.push({ field: 'valor', headerName: 'Valor', flex: 1, valueGetter:({value}) => Number(value || 0), renderCell: ({ value }) => formatCurrency(value || 0) })
    documentos_quitados.push({ field: 'atraso', headerName: 'Atraso', flex: 1 })
    documentos_quitados.push({ field: 'tipo_doc', headerName: 'Tipo Doc', flex: 1 })
    documentos_quitados.push({ field: 'cliente', headerName: 'Cliente', flex: 1 })

    empresas_do_grupo.push({field: 'Nome', headerName: 'Nome', flex: 1})
    empresas_do_grupo.push({field: 'CPF_CNPJ', headerName: 'CNPJ/CPF', flex: 1})
    

    return {
        documentos_em_aberto: documentos_em_aberto,
        documentos_quitados: documentos_quitados,
        empresas_do_grupo: empresas_do_grupo
    }
}

const FichaFinanceira = ({ id, data, valor, setData }) => {

    const { setLoader } = useContext(externalComponent)

    useEffect(() => {
        if (!data.loaded)
            initialize(id, setData, setLoader)
    }, [data])

    const setColumns = useMemo(() => generateColumns(), [])

    return (
        <Box className='ficha-financeira-main-window'>
            <Box className='ficha-financiera-left'>
                <Box className='ficha-financiera-status'>Status do cliente: <span>{data.status || 'Normal'}</span></Box>
                <Box className='ficha-financiera-limite'>
                    <Box className='ficha-financeira-limite-table'>
                        <Box className='ficha-financeira-limite-table-left'>
                            <Box className='ficha-financeira-limite-credito' >Limite de Crédito:</Box>
                            <Box></Box>
                            <Box>Títulos em Aberto:</Box>
                            <Box>Este Pedido:</Box>
                            <Box>Saldo:</Box>
                        </Box>
                        <Box className='ficha-financeira-limite-table-right'>
                            <Box>
                               <Box className='ficha-fixsize' sx={{color: 'blue'}}>{formatCurrency(data?.rows?.limite_de_credito)}</Box>
                            </Box>
                            <Box>
                                <Box className='ficha-fixsize'></Box>
                            </Box>
                            <Box >
                                <Box className='ficha-fixsize'>{formatCurrency(data.rows?.valor_total_aberto || 0)}</Box>
                            </Box>
                            <Box>
                                <Box className='ficha-fixsize'>{formatCurrency(valor / 100)}</Box>
                            </Box>
                            <Box className='ficha-financeira-limite-credito'>
                                <Box className='ficha-fixsize'>{formatCurrency(Number(data?.rows?.limite_de_credito || 0)-(Number(data.rows?.valor_total_aberto || 0)) - ((valor || 0) / 100))}</Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box className='ficha-financiera-empresas'>
                    <Box>Empresas do grupo</Box>
                    <Table
                        disableRowSelectionOnClick
                        paginationMode='client'
                        className='contabil-grid'
                        rows={data.rows?.empresas_do_grupo || []}
                        columns={setColumns.empresas_do_grupo || []}
                        pagination={false}
                        toolbar
                        slots={{
                            filterComponent: false,
                            columnComponent: false
                        }}
                        density='compact'
                        rowHeight={30}
                        hideFooter={true}
                    />
                </Box>
                <Box className='ficha-financiera-pendencias'>
                    <Box>Pendência financeira</Box>
                    <Table
                        disableRowSelectionOnClick
                        paginationMode='client'
                        className='contabil-grid'
                        rows={data.pendencias || []}
                        columns={setColumns.pendencias || []}
                        pagination={false}
                        toolbar
                        slots={{
                            filterComponent: false,
                            columnComponent: false
                        }}
                        density='compact'
                        rowHeight={30}
                        hideFooter={true}
                    />
                </Box>
            </Box>
            <Box className='ficha-financiera-right'>
                <Box className='ficha-financiera-doc-quitado'>
                    <Box className='flex'><Box>Documentos quitados</Box><Box>Valor total quitados: {formatCurrency(data.rows?.valor_total_quitado || 0)}</Box></Box>
                    <Box sx={{ height: '100%' }}>
                        <Table
                            disableRowSelectionOnClick
                            paginationMode='client'
                            className='contabil-grid'
                            rows={data.rows?.documentos_quitados || []}
                            columns={setColumns.documentos_quitados || []}
                            pagination={false}
                            toolbar
                            slots={{
                                filterComponent: false,
                                columnComponent: false
                            }}
                            density='compact'
                            rowHeight={30}
                            hideFooter={true}
                        />
                    </Box>
                </Box>
                <Box className='ficha-financiera-doc-aberto'>
                    <Box className='flex'><Box>Documentos em aberto</Box><Box>Valor total em aberto: {formatCurrency(data.rows?.valor_total_aberto || 0)}</Box></Box>
                    <Table
                        disableRowSelectionOnClick
                        paginationMode='client'
                        className='contabil-grid'
                        rows={data.rows?.documentos_em_aberto || []}
                        columns={setColumns.documentos_em_aberto || []}
                        pagination={false}
                        toolbar
                        slots={{
                            filterComponent: false,
                            columnComponent: false
                        }}
                        density='compact'
                        rowHeight={30}
                        hideFooter={true}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default FichaFinanceira